export enum DataHooks {
  WRAPPER = 'header-title-wrapper',
  TITLE = 'header-title',
}
